import { Injectable } from '@angular/core';
import { CloserSyncTransaction } from '@models/mortgages/closer-sync-instruction';
import { State } from '@ngxs/store';
import { CollectionPaths } from '@models/collections';
import {
	FirestoreStateBaseForBusinessWithSubscription,
	BusinessWithSubscriptionStateModel,
} from '@state/FirestoreStateBaseForBusiness';
import { DEFAULT_STATE_BASE } from '@state/FirestoreStateBase';

export interface SyncMortgagesInstructionsStateModel
	extends BusinessWithSubscriptionStateModel {
	data: CloserSyncTransaction[];
}

const DEFAULT_STATE: SyncMortgagesInstructionsStateModel = {
	...DEFAULT_STATE_BASE,
	data: [],
};

@State<SyncMortgagesInstructionsStateModel>({
	name: 'syncMortgagesInstructions',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class SyncMortgagesInstructionsState extends FirestoreStateBaseForBusinessWithSubscription<
	CloserSyncTransaction,
	SyncMortgagesInstructionsStateModel
> {
	constructor() {
		super(
			(pathParams) =>
				CollectionPaths.business_mortgagesV2(pathParams.businessId),
			(doc) => ({ data: doc as CloserSyncTransaction[] }),
			() => DEFAULT_STATE,
		);
	}
}
